// Custom hook to limit the number of characters in a string
// Return only if the initial value has exceeded the limit
import {
  useEffect,
  useState,
} from 'react';

export default function useCharLimiter(
  initialValue: string,
  limit: number,
) {
  const [exceededChars, setExceededChars] = useState<number>(0);
  const [hasExceededLimit, setHasExceededLimit] = useState<boolean>(false);

  useEffect(() => {
    // Count string length matching PHP's strlen() behavior
    // When textarea content is sent to server, browsers convert \n to \r\n
    // So we need to count each \n as 2 characters to match PHP
    // This is only for counting - the actual value is not modified
    const lineBreaks = (initialValue.match(/\n/g) || []).length;
    const actualLength = initialValue.length + lineBreaks;

    if (actualLength > limit) {
      setExceededChars(actualLength - limit);
      setHasExceededLimit(true);
    } else {
      setExceededChars(0);
      setHasExceededLimit(false);
    }
  }, [initialValue, limit]);

  return {
    hasExceeded: hasExceededLimit,
    exceededChars,
  };
}
